"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPlayerContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const FloatingPlayerContainer_module_css_1 = __importDefault(require("./FloatingPlayerContainer.module.css"));
/**
 * Player Container wrapping all the other components
 */
function FloatingPlayerContainer({ onCloseClick, children, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: FloatingPlayerContainer_module_css_1.default.floatingPlayerContainer, children: [children, (0, jsx_runtime_1.jsx)("span", { className: FloatingPlayerContainer_module_css_1.default.closeButtonWrapper, "data-testid": "floatingPointClose", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.IconButton, { color: "rgba(0, 0, 0, 0.2)", onClick: onCloseClick, size: "SMALL", label: "Close", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.CrossIcon, { size: web_core_ui_1.Sizes.Large, fill: "#ffffff" }) }) })] }));
}
exports.FloatingPlayerContainer = FloatingPlayerContainer;
//# sourceMappingURL=FloatingPlayerContainer.js.map